import React from 'react';
import { Button } from './Input/Button';

export const Message = ({
  current,
  onDismiss,
}) => {
  if (current === null) {
    return null;
  }
  return (
    <div className="alert">
      <div className={current.kind}>
        <span>{current.message}</span>
        <div style={{textAlign: 'right'}}>
          <Button label="OK" onClick={() => onDismiss(current.id)} />
        </div>
      </div>
    </div>
  );
};
